import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AddPhotoImageData } from "../../../types";
import { addReview, addReviewDesktop } from "../../../apis";
import { Storage } from "common/storage";

export function usePostVenueReview(isDesktop?: boolean) {
  const accessToken = Storage.getCurrentUserToken();
  const queryClient = useQueryClient();
  const { mutate, error, status, data } = useMutation({
    mutationFn: ({
      venueId,
      review,
      images,
      accessibilityExperience,
    }: {
      images: AddPhotoImageData[];
      venueId: string;
      review: string;
      accessibilityExperience: string;
    }) => {
      return isDesktop
        ? addReviewDesktop(
            venueId,
            review,
            images,
            accessibilityExperience,
            accessToken || ""
          )
        : addReview(
            venueId,
            review,
            images,
            accessibilityExperience,
            accessToken || ""
          );
    },
    onSuccess: (_, { venueId }) => {
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: ["loadVenueDetailsBySlug"],
          exact: false,
        });
      }, 2000);
    },
  });

  return { mutate, error, status, data };
}
